/*@ngInject*/
module.exports = function() {
    return {
        scope: {
            object: '=',
            imageFiles: '=',
            modal: '='
        },
        bindToController: true,
        controllerAs: 'vm',
        /*@ngInject*/
        controller: function($uibModal) {
            let vm = this;

            vm.modal = {
                show: false,
                form: {},
                data: {},
                showErrors: false,
                uploading: false
            };

            vm.$onInit = function() {
                vm.imageFiles = $.map(vm.object.version.image_files, function(item) {
                    const names = {};
                    for(let index in item.name) {
                        const name = item.name[index];
                        names[name.language] = name;
                    }
                    return {id: item.id, filename: item.filename, name: names};
                });
            };

            vm.showFileModal = (file) => {
                const index = file ? vm.imageFiles.indexOf(file) : -1;
                vm.modal.data = $.extend({}, file || {
                    name: {
                        est: {},
                        eng: {},
                        rus: {}
                    }
                }, {
                    index: index
                });

                $uibModal.open({
                    template: require('./objects-edit-image-files-modal.html'),
                    controller: require('./objects-edit-image-files-modal.directive'),
                    controllerAs: 'vm',
                    size: 'lg',
                    resolve: {
                        data() {
                            return { modal: vm.modal, object: vm.object, imageFiles: vm.imageFiles};
                        }
                    }
                });
            };

            vm.removeFile = function(file) {
                const index = file ? vm.imageFiles.indexOf(file) : -1;
                if(index !== -1) {
                    if(window.confirm('Kas oled kindel?')) {
                        vm.imageFiles.splice(index, 1);
                    }
                }
            };

            vm.isFirstFile = function(file) {
                return 0 === vm.imageFiles.indexOf(file);
            };

            vm.isLastFile = function(file) {
                return (vm.imageFiles.length - 1) === vm.imageFiles.indexOf(file);
            };

            vm.moveFileLeft = function(file) {
                const index = vm.imageFiles.indexOf(file);
                if(!vm.isFirstFile(file)) {
                    const item = vm.imageFiles.splice(index, 1)[0];
                    vm.imageFiles.splice(index - 1, 0, item);
                }
            };

            vm.moveFileRight = function(file) {
                const index = vm.imageFiles.indexOf(file);
                if(!vm.isLastFile(file)) {
                    const item = vm.imageFiles.splice(index, 1)[0];
                    vm.imageFiles.splice(index + 1, 0, item);
                }
            };
        },

        template: require('./objects-edit-image-files.html')
    };
};



/** WEBPACK FOOTER **
 ** ./app/shared/directives/objects/edit/directives/objects-edit-image-files.directive.js
 **/